import styled from "styled-components";
import themeProps from "theme/themes";
import arrowDown from "assets/icons/arrow_down.svg";
import { ChangeEvent, Dispatch, SetStateAction } from "react";

interface SelectProps {
  options: string[];
  selected: string;
  handleChange: Dispatch<SetStateAction<string>>;
  hightlightFirstOption?: boolean;
}

const WrapperBasic = styled.select`
  width: 100%;
  padding: 10px 15px;
  border-radius: 12px;
  outline: none;
  border: 1px solid ${(props: themeProps) => props.theme.border.primary};
  appearance: none;
  background-image: url(${arrowDown});
  background-repeat: no-repeat;
  background-position-y: 55%;
  background-position-x: 97%;
  background-size: 20px;
  cursor: pointer;
`;

const Wrapper = styled(WrapperBasic)(
  ({ hightlight }: { hightlight?: boolean }) => ({
    color: hightlight ? "#7D02FA" : "#000",
  })
);

const Select = ({
  options,
  selected,
  handleChange,
  hightlightFirstOption,
}: SelectProps) => {
  return (
    <Wrapper
      value={selected}
      onChange={(e: ChangeEvent<HTMLSelectElement>) => {
        handleChange(e.target.value);
      }}
      hightlight={hightlightFirstOption && selected === options[0]}
    >
      {options.map((option, index) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </Wrapper>
  );
};

export default Select;
